import { Colors } from '../../consts/Colors';
import RoundedButton2 from '../RoundedButton2';
import Card3 from './Card3';
import { CartesInfos, TextContents } from '../../consts/DataGame3.js';
import DragManager from '../DragManager';

// Création du deck de jeu pour la partie 3

export default class Deck3 extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.isFirstDrop = true
        this.placeholders = [];
        this.cartes = [];


        this.rect = this.scene.add.rexRoundRectangle(0, 0, 416, 593, 26, Colors.Elmt.Beige).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);

        this.validBtn = new RoundedButton2(this.scene, 0, 247, 154, "Valider");
        this.add(this.validBtn);
        this.validBtn.setClickFunction(() => {
            this.checkAnswer()
        })

        this.dragManager = new DragManager(this.scene);
        for (let i = 0; i < CartesInfos.length; i++) {
            const el = CartesInfos[i];
            let ph = this.scene.add.image(el.cardX, el.cardY, el.placeholder).setOrigin(0.5);
            this.add(ph);
            this.placeholders.push(ph);

            this.carte = new Card3(this.scene, el.cardX, el.cardY, el, this);
            this.add(this.carte);
            this.cartes.push(this.carte);
            this.dragManager.addDraggable(this.carte);
        }

        this.validBtn.setLocked()

        this.title = this.scene.createTextElement(-171, -474, TextContents.title)
                this.subtitle = this.scene.createTextElement(-171, this.title.y + this.title.height + 16, TextContents.subtitle)
                this.consigne = this.scene.createTextElement(-167, 352, TextContents.consigne)
        this.add(this.title)
        this.add(this.subtitle)
        this.add(this.consigne)
    }
    setDeckTrue() {
        this.repLogo = this.scene.add.image(-93, -60, 'goodAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(-59, -75, "BRAVO", {
            font: "40px MassiliaBold",
            color: Colors.Text.Green
        }).setOrigin(0)
        this.add(this.repText)
        this.repContent = this.scene.add.text(0, -25, TextContents.bravo.text, {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "center",
            wordWrap: { width: 340, useAdvancedWrap: true }
        }).setOrigin(0.5, 0)
        this.add(this.repContent)
        this.nextBtn = new RoundedButton2(this.scene, 0, 231, 188, "Continuer");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.scene.transitionOut()
        })
    }
    setDeckFalse(score) {
        let content
        let nbMauvaiseReponse = this.cartes.length - score
        if (nbMauvaiseReponse == 1) {
            content = nbMauvaiseReponse + " MAUVAISE RÉPONSE"
        } else {
            content = nbMauvaiseReponse + " MAUVAISES RÉPONSES"
        }

        this.repLogo = this.scene.add.image(0, -72, 'badAnswer').setOrigin(0.5)
        this.add(this.repLogo)
        this.repText = this.scene.add.text(0, -24, content, {
            font: "40px MassiliaBold",
            color: Colors.Text.Red,
            wordWrap: { width: 255, useAdvancedWrap: true },
            align: "center"
        }).setOrigin(0.5, 0)
        this.add(this.repText)
        this.nextBtn = new RoundedButton2(this.scene, 0, 245, 188, "Réessayer");
        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            this.cartes.forEach(carte => {
                if (carte.isCorrect === false) {
                    carte.zoneDropped.reset()
                    carte.reset()
                }
            })

            this.nextBtn.destroy()
            this.placeholders.forEach(ph => { ph.setAlpha(1) })
            this.validBtn.setAlpha(1)
            this.validBtn.setLocked()
            this.repLogo.destroy()
            this.repText.destroy()
        })
    }

    checkAnswer() {
        this.result = 0
        this.cartes.forEach(carte => {
            carte.disableInteractive()
            if (carte.zoneDropped.zoneId === carte.zoneId) {
                if (carte.isFirstDrop === true) {
                    this.scene.game.data.score.bravo++
                }
                carte.setGood()
                carte.isCorrect = true
                this.result++
            } else {
                carte.isCorrect = false
                if (carte.isFirstDrop === true) {
                    this.scene.game.data.score.mauvais++
                }
                carte.setBad()
            }
            carte.isFirstDrop = false
        })
        this.placeholders.forEach(ph => { ph.setAlpha(0) })
        this.validBtn.setAlpha(0)
        if (this.result == 4) {
            this.setDeckTrue()
        } else {
            this.setDeckFalse(this.result)
        }
    }

    update(){
        let nbr = this.cartes.filter(x => x.isDone).length
        if (nbr == this.cartes.length) {
            this.validBtn.setUnlocked()
        }
    }
}
